import IpsFilePicker from './IpsFilePicker.vue';
import '../../../styles/custom.scss';

export default IpsFilePicker;
